export enum EMenuItemStyle {
  default,
  side = 'side',
}
